// §119 appearance, for the canvas-drawn components.
//
// CSS needs none of this: libretto.css is written in light-dark() against
// `color-scheme`, so a theme change repaints every styled element by itself. The
// chart and the drive map draw into a canvas from colours they resolved once, so
// they have to be told – both WHICH theme is in force, and WHEN it changed.
//
// Which: the reader's choice on <html data-theme> wins over the operating system's
// preference, and only its absence ("auto") falls back to the media query. Asking
// the media query alone – which is what these components used to do – paints a dark
// chart onto a light page for anyone who chose light on a dark desktop.
//
// When: the media query fires only for a change of the OS preference. A click on the
// switch is a change of the attribute instead, announced as sb-theme-change (the
// component's own event), so both are listened for.

/** True when the page is currently painting its dark palette. */
export function isDarkTheme(): boolean {
  const chosen = document.documentElement.dataset.theme;
  if (chosen === 'dark') return true;
  if (chosen === 'light') return false;
  return window.matchMedia('(prefers-color-scheme: dark)').matches;
}

/** Calls back on every theme change, from the OS or from the switch. Returns the undo. */
export function onThemeChange(fn: () => void): () => void {
  const mql = window.matchMedia('(prefers-color-scheme: dark)');
  mql.addEventListener('change', fn);
  window.addEventListener('sb-theme-change', fn);
  return () => {
    mql.removeEventListener('change', fn);
    window.removeEventListener('sb-theme-change', fn);
  };
}
